module.exports = __webpack_public_path__ + "img/help.55742396.svg";